import React, { Component } from 'react'
import { Redirect, withRouter } from 'react-router-dom'
import Loading from '../../pages/Loading'

class UserAuthentication extends Component {
  constructor(props) {
    super(props)
  }
  componentDidMount() {
    if (!sessionStorage.getItem('JW_TOKEN')) {
      let search = window.location.search
      if (this.props.location.pathname !== "" && this.props.location.pathname !== "/") {
        search += "&path=" + this.props.location.pathname
      }
      window.location.assign('/api/login/enrol' + search)
    }
  }

  render() {
    if (sessionStorage.getItem('JW_TOKEN')) {
      return this.props.children
    }
    return <Loading />
  }
}

export default withRouter(UserAuthentication)
